module.exports = __webpack_public_path__ + "img/bg.5a32d80f.svg";